/**
 * 接口域名的管理
 */
const base = {
    sq: 'https://xxxx111111.com/api/v1',
    sr: 'http://192.168.1.167:9201/hawk',
    ss: 'http://192.168.0.44:9201/hawk',
    fm: 'http://180.76.185.187:8090/api',
    fm2: '/api'
}

export default base;